// extracted by mini-css-extract-plugin
module.exports = {"root":"ProfileIcon__root--3kRUa"};